// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2aBlX","location":"Header_location__3VfKm"};